export var TimePeriodUnit;
(function (TimePeriodUnit) {
    TimePeriodUnit["YEAR"] = "year";
    TimePeriodUnit["MONTH"] = "month";
})(TimePeriodUnit || (TimePeriodUnit = {}));
export var PriceEvolutionLevel;
(function (PriceEvolutionLevel) {
    PriceEvolutionLevel["HIGH"] = "high";
    PriceEvolutionLevel["LOW"] = "low";
    PriceEvolutionLevel["EQUAL"] = "equal";
})(PriceEvolutionLevel || (PriceEvolutionLevel = {}));
